module.exports = __webpack_public_path__ + "img/ANTENNA 1 LIME.47dd5fd.svg";